<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <b-button icon-pack="fas" icon-left="times" @click="emitClose" />
    </header>
    <section class="modal-card-body">
      <notificationGroupsEdit
        @group-update-complete="emitClose"
        :canEditNotificationGroup="canCreateNotificationGroups"
        @cancel-update="emitClose"
        :shopId="props.id"
      />
    </section>
    <footer class="modal-card-foot">
      <b-button @click="emitClose">{{ $t('Close') }}</b-button>
    </footer>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useAppStore } from '@/stores/app'
import notificationService from '@/services/notificationService'
import notificationGroupsEdit from '@/components/notifications/notificationGroupsEdit.vue'

// Props
const props = withDefaults(defineProps<{
  id?: number
}>(), {
  id: undefined
})

// Emits
const emit = defineEmits<{
  (e: 'close'): void
}>()

const closeQueued = ref(false)

// Composables
const appStore = useAppStore()

// Computed
const notificationGroupList = computed(() => appStore.getNotificationGroups)

const canCreateNotificationGroups = computed(() => {
  const groups = notificationGroupList.value ?? []
  // Type assertion to match the service expectation
  const typedGroups = groups.map(group => ({
    ...group,
    canUpdateNotificationGroup: group.canUpdateNotificationGroup ?? false
  }))
  return notificationService.canCreateGroup(typedGroups)
})

const emitClose = (): void => {
  if (closeQueued.value) {
    return
  }

  closeQueued.value = true
  try {
    emit('close')
  } finally {
    queueMicrotask(() => {
      closeQueued.value = false
    })
  }
}

// Lifecycle
onMounted(async () => {
  if (
    notificationGroupList.value === null ||
    notificationGroupList.value.length === 0
  ) {
    await notificationService.getNotificationGroups()
  }
})
</script>

